import { useRequest } from '../api/hooks';
import { GMTInfo, Page } from './common';
import dayjs from 'dayjs';

export const StaffEndpoint = `/admin`;

/** 企业用户 */
export interface Staff extends GMTInfo {
  id: number;

  /**用户名 */
  username: string;

  nickname: string;
  intro: string;
  /**头衔 */
  title: string;

  /**电话 */
  tel: string;

  /**邮箱 */
  email: string;

  /**密码 */
  password?: string;

  /**密码 */
  newPassword?: string;

  /**密码 */
  newPasswordConfirm?: string;

  /**头像 */
  avatar?: string;

  /**上次登录时间 */
  lastLoginTime?: string | dayjs.Dayjs;

  /**企业 id */
  poiId?: string;

  /**角色 ids */
  roleIds?: number[];

  weixinOpenid: string;

  isOperator: boolean;
}

export const requestOperatorList = () =>
  useRequest<Staff[]>(
    {
      method: 'get',
      url: `${StaffEndpoint}/operator`,
    },
    { manual: true }
  );

export const useRequestStaffList = () =>
  useRequest<{
    list: Staff[];
    page: Page;
    roleMap: { [id: number]: number[] };
  }>(
    {
      method: 'get',
      url: `${StaffEndpoint}`,
      params: {},
    },
    {
      manual: true,
    }
  );

export const useRequestAllStaffList = (autoFetch = true) =>
  useRequest<Staff[]>(
    {
      method: 'get',
      url: `${StaffEndpoint}/all`,
    },
    {
      manual: !autoFetch,
    }
  );

export const useRequestStaff = () => {
  const { send, ...rest } = useRequest<Staff[]>(
    {
      method: 'get',
      url: `${StaffEndpoint}/username/{username}`,
    },
    {
      manual: true,
    }
  );
  return {
    ...rest,
    send: (username: string) => {
      return send({
        pathVars: { username },
      });
    },
  };
};

export const useRequestUpsertStaff = () => {
  const { send, ...rest } = useRequest(
    {
      url: `${StaffEndpoint}`,
    },
    {
      manual: true,
    }
  );
  return {
    ...rest,
    send: (staff: Staff) => {
      return send({
        method: staff.username ? 'put' : 'post',
        data: staff,
      });
    },
  };
};
